// DS: i4.18
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Calendar: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M14.452 1.545h-.773V0h-1.546v1.545H3.875V0H2.329v1.545h-.772A1.55 1.55 0 0 0 .01 3.091v11.322c0 .85.696 1.545 1.546 1.545h12.895a1.55 1.55 0 0 0 1.545-1.545V3.09a1.55 1.55 0 0 0-1.545-1.546zM14.019 14H2V5h12.019v9z"
          id="I71-a"
        />
      </defs>
      <g transform="translate(4 4)" fill="currentColor" fillRule="evenodd">
        <use fillRule="nonzero" xlinkHref="#I71-a" />
        <path d="M4 7h2v2H4zM4 10h2v2H4zM7 7h2v2H7zM7 10h2v2H7zM10 7h2v2h-2zM10 10h2v2h-2z" />
      </g>
    </svg>
  </IconWrap>
);
Calendar.displayName = 'Calendar';

export default Calendar;
